/**
 * Environment Configuration
 * Automatically detects production vs local environment
 */

export const ENV = {
  // Environment detection
  isProd: window.location.hostname !== 'localhost',
  isLocal: window.location.hostname === 'localhost',

  // API URLs - empty string for production (paths already include /api)
  apiUrl: window.location.hostname === 'localhost'
    ? 'http://localhost:4001'
    : '',

  // Base URLs
  baseUrl: window.location.hostname === 'localhost'
    ? 'http://localhost:4000'
    : `https://${window.location.hostname}`,

  // Backend URL
  backendUrl: window.location.hostname === 'localhost'
    ? 'http://localhost:4001'
    : `https://${window.location.hostname}`,

  // WebSocket URL for HMR
  wsUrl: window.location.hostname === 'localhost'
    ? 'ws://localhost:4000'
    : `wss://${window.location.hostname}`,

  // Current environment name
  environment: window.location.hostname === 'localhost' ? 'local' : 'production',
} as const;

// Log environment on load (useful for debugging)
if (import.meta.env.DEV) {
  console.log('🌍 Environment:', {
    mode: ENV.environment,
    hostname: window.location.hostname,
    apiUrl: ENV.apiUrl,
    baseUrl: ENV.baseUrl,
    backendUrl: ENV.backendUrl,
  });
}
